import axios, {AxiosBasicCredentials, AxiosResponse, ResponseType} from "axios";
import createInfoObject from "@/lib/create-info-object";
import getBearerAuth from "@/lib/get-bearer-auth";

class Service {
    nodeUniqueId: string;
    auth: AxiosBasicCredentials;
    url: string;

    constructor() {
        this.nodeUniqueId = process.env.VUE_APP_NODE_UNIQUE_ID;
        this.auth = {
            username: process.env.VUE_APP_API_KEY,
            password: process.env.VUE_APP_API_SECRET
        };
        this.url = process.env.VUE_APP_SERVICE_URL + '/' + process.env.VUE_APP_SERVICE_PORTFOLIO + '/info/' + process.env.VUE_APP_SERVICE_VERSION;
    }

    /**
     * @param {String} type
     * @param {Object} payload
     * @param {String} context
     * @param {String} mode
     */
    // eslint-disable-next-line
    request(type: string,  payload?: object, context = 'USER', mode = '',responseType:ResponseType = 'json',sendDirectData:boolean = false): Promise<any> {
        return new Promise((resolve, reject) => {
            const requestData = createInfoObject(type, payload, context, mode);

            let auth;

            switch (context) {
                case 'USER':
                    auth = getBearerAuth();
                    break;
                case 'WEBAPP':
                    auth = getBearerAuth();
                    break;
                case 'PUBLIC':
                    auth = {
                        auth: this.auth
                    };
                    break;
            }

            axios.post(this.url, requestData, {...auth,responseType})
                .then((response : AxiosResponse) => {
                    if(!sendDirectData){
                        return resolve(response.data.data)
                    }
                    return resolve(response.data)
                })
                .catch((error: Record<string, unknown>) => reject(error));
        });
    }
}

export default Service;
